var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86 17.65L6.2 16L5 19L7.86 17.65Z",
    fill: "#9135E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9393 9L15 6.06066L16.0607 5L19 7.93934L17.9393 9Z",
    fill: "#9135E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.414 4.4459C17.414 4.44588 17.4145 4.44598 17.4155 4.44623L17.414 4.4459ZM17.5492 4.51131C17.6161 4.55337 17.6975 4.61619 17.7832 4.70394L19.2895 6.21037C19.3776 6.29842 19.4414 6.3842 19.484 6.45526L9.53724 16.402L6.27915 17.7207L7.5979 14.4626L17.5492 4.51131ZM18.8531 3.65267C18.5893 3.38327 18.2739 3.1618 17.9481 3.04295C17.6747 2.9432 17.1123 2.8269 16.6895 3.24971L6.3218 13.6174L3.56055 20.4393L10.3825 17.6781L20.7502 7.31037C21.1773 6.8832 21.0412 6.30866 20.9499 6.05694C20.8331 5.73462 20.6171 5.41665 20.3502 5.14971L18.8531 3.65267Z",
    fill: "#9135E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.9ff8cc205e94d861961aa9212e338d0f.svg";
export { ForwardRef as ReactComponent };